import winston from 'winston'

const myFormatter = winston.format.printf((data) => {
  const { level, message, timestamp, ...meta } = data;
  return `
  {"appTime": "${timestamp}", "appLevel":"${level}", "appMessage":"${message}"${process.env.CONTAINER_NAME ? `, "appName":"${process.env.CONTAINER_NAME}"` : `, "appName":"Unknown"`}${meta.label ? `, "appLabel":"${meta.label}"` : `` }${meta.data ? `, "appData":${JSON.stringify(meta.data)}` : `` } }`
})

export const logger = winston.createLogger({
  level:'debug',
  format: winston.format.combine(
    winston.format.timestamp({ format: 'DD/MM/YYYY HH:mm:ss' }),
    myFormatter
  ) ,
  transports: [
    new winston.transports.Console()
  ]
})